import axios from "axios";
import { getS3PreSignedUrl } from "@query/getS3PreSignedUrl";

export const uploadToS3 = async (fileName, Body, contentType, onProgress, fileType) => {
  try {
    const url = await getS3PreSignedUrl({
      fileName,
      contentType,
      expirationTime: 3600,
      fileType,
    });
    const instance = axios.create();
    delete instance.defaults.headers.common['Authorization'];
    instance.defaults.headers.put[ "Content-Type" ] = contentType;
    const res = await instance.request({
      method: "PUT",
      url,
      data: Body,
      onUploadProgress: onProgress,
      // headers: {
      //   "x-amz-acl": "public-read",
      // }
    })
    
    return {
      Location: url.split("?")[0],
      ETag: res.headers.etag.replace(/"/g, ""),
      Key: fileName,
    }
  } catch (e) {
    console.error(e);
  }
};

export const deleteFromS3 = async (filePath, isFont) => {
  try {
    const url = await getS3PreSignedUrl({
      fileName: filePath,
      expirationTime: 3600,
      isFont,
      deleteObjectAction: true,
    });
    
    const instance = axios.create();
    delete instance.defaults.headers.common['Authorization'];
    return await instance.request({
      method: "DELETE",
      url,
    });
  } catch (e) {
    console.error(e);
  }
}